var _dec, _class, _BreadcrumbLink;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Link } from '@instructure/ui-link';
import { omitProps } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
import { Tooltip } from '@instructure/ui-tooltip';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
parent: Breadcrumb
id: Breadcrumb.Link
---
**/
let BreadcrumbLink = (_dec = testable(), _dec(_class = (_BreadcrumbLink = class BreadcrumbLink extends Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
    this.state = {
      isTruncated: false
    };
  }
  handleTruncation(isTruncated) {
    if (isTruncated !== this.state.isTruncated) {
      this.setState({
        isTruncated
      });
    }
  }
  render() {
    const _this$props = this.props,
      children = _this$props.children,
      href = _this$props.href,
      renderIcon = _this$props.renderIcon,
      iconPlacement = _this$props.iconPlacement,
      onClick = _this$props.onClick,
      onMouseEnter = _this$props.onMouseEnter,
      isCurrentPage = _this$props.isCurrentPage;
    const isTruncated = this.state.isTruncated;
    const props = omitProps(this.props, BreadcrumbLink.allowedProps);
    return _jsx(Tooltip, {
      renderTip: children,
      preventTooltip: !isTruncated,
      children: _jsx(Link, {
        ...props,
        href: href,
        renderIcon: renderIcon,
        iconPlacement: iconPlacement,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isWithinText: false,
        elementRef: this.handleRef,
        forceButtonRole: false,
        ...(isCurrentPage && {
          'aria-current': 'page'
        }),
        children: _jsx(TruncateText, {
          onUpdate: isTruncated => this.handleTruncation(isTruncated),
          children: _jsx("span", {
            "aria-hidden": isTruncated,
            children: children
          })
        })
      })
    });
  }
}, _BreadcrumbLink.displayName = "BreadcrumbLink", _BreadcrumbLink.componentId = 'Breadcrumb.Link', _BreadcrumbLink.propTypes = propTypes, _BreadcrumbLink.allowedProps = allowedProps, _BreadcrumbLink.defaultProps = {}, _BreadcrumbLink)) || _class);
export default BreadcrumbLink;
export { BreadcrumbLink };